import ModelUtil from '@leverege/model-util';
const TYPE = 'variantizer.Value';
function create() {
  return {
    type: TYPE,
    variant: null
  };
}
function variantFor(model, obj, context) {
  return model.variant;
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('variant'),
  variantFor
};